import { render, staticRenderFns } from "./studyTheList.vue?vue&type=template&id=57cf7987&scoped=true&"
import script from "./studyTheList.vue?vue&type=script&lang=js&"
export * from "./studyTheList.vue?vue&type=script&lang=js&"
import style0 from "./studyTheList.vue?vue&type=style&index=0&id=57cf7987&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cf7987",
  null
  
)

export default component.exports